/**
 * `PaymentStatus` hub — the authoritative signal that funds are held awaiting verification.
 *
 * Per the contract the message is `{ result_status: 'processing', awaiting_verification: true,
 * user_card_id }`, and it is **also sent on connect**. That second part is what makes state
 * restoration free: a player who closes the widget mid-hold and comes back gets told about the hold
 * as soon as the listener attaches, with no extra endpoint.
 *
 * The constants duplicate `services/notificationService/constants` by value rather than importing
 * them, for the same reason as `reservationNotifications.ts`: this directory must stay deletable.
 * `NotificationService` itself is generic transport, so reusing it creates no coupling.
 */
export const RESERVATION_HOLD_URL = '/notifications';

export const RESERVATION_HOLD_TARGET = 'PaymentStatus';

export interface ReservationHoldMessage {
  result_status?: string;
  /** Not in the generated models — read through this local shape so `APIModels.ts` stays untouched. */
  awaiting_verification?: boolean | string;
  user_card_id?: number;
}

/**
 * Tolerates the string form: notification payloads in this widget frequently deliver booleans
 * as `"true"`.
 */
export const isAwaitingVerification = (payload?: ReservationHoldMessage | null): boolean =>
  payload?.awaiting_verification === true || payload?.awaiting_verification === 'true';
